import { memo, useCallback } from 'react'

import { Chip } from '~/shared/ui/Chip'
import { HStack } from '~/shared/ui/HStack'

import type { ChipGroupProps } from './types'

/**
 * Группа чипов поверх Row(wrap). SINGLE выбирает ровно один вариант (повторный тап
 * по уже выбранному ничего не убирает — это выбор, не тумблер), MULTI — добавляет/убирает.
 */
export const ChipGroup = memo(function ChipGroup(props: ChipGroupProps) {
  const {
    mode,
    options,
    value,
    onChange,
    chipVariant = 'ANSWER',
    chipSize = 'M',
    wrap = true,
    gap = 'SMALL_M',
    align = 'START',
  } = props

  const handlePress = useCallback(
    (key: string) => {
      if (mode === 'SINGLE') {
        if (value.length === 1 && value[0] === key) return
        onChange([key])
        return
      }

      const isSelected = value.includes(key)
      onChange(isSelected ? value.filter((item) => item !== key) : [...value, key])
    },
    [mode, value, onChange],
  )

  return (
    <HStack wrap={wrap} gap={gap} justify={align === 'CENTER' ? 'CENTER' : 'START'} align='CENTER'>
      {options.map((option) => (
        <Chip
          key={option.key}
          text={option.text}
          size={chipSize}
          variant={chipVariant}
          isSelected={value.includes(option.key)}
          isDisabled={option.isDisabled}
          onPress={() => handlePress(option.key)}
        />
      ))}
    </HStack>
  )
})
